/*
 * Leuchtvolley: Warenkorb-Abgleich.
 *
 * Aufgaben (SPEC §5):
 *  1. Shipping Protection „immer im Einkaufswagen": liegt ein Ball im Korb und fehlt die
 *     Protection, kommt sie automatisch dazu (Gratis-Variante, wenn der Kunde Anspruch hat,
 *     sonst die bezahlte). Schaltet der Kunde sie ab, bleibt sie fuer die Sitzung aus.
 *  2. Liegt die Gratis-Variante im Korb, wird nichts doppelt ergaenzt (Dubletten fliegen raus).
 *  3. Kein Ball mehr im Korb: Protection und alle 0-€-Beigaben werden automatisch entfernt.
 *  4. Checkout-Sperre: ohne Ball kein Checkout (Liquid rendert Hinweis + gesperrten Button,
 *     dieses Skript sperrt zusaetzlich jeden anderen Checkout-Weg).
 *  5. Schalter der Protection-Box, Upsell-Knopf „Hinzufügen", Reservierungs-Chip.
 *
 * Schutz gegen Schleifen und Doppel-Requests:
 *  - alle Warenkorb-Aenderungen laufen durch EINE Warteschlange (nie parallel),
 *  - Abgleich entprellt (200 ms) und hoechstens einmal eingereiht,
 *  - Entscheidungen nur auf frischen Daten: vollstaendiger Warenkorb aus dem Event, der
 *    Schnappschuss aus der mitgerenderten Section oder GET /cart.js,
 *  - Notbremse: hoechstens 8 automatische Aenderungen pro Seitenaufruf, nach einem
 *    fehlgeschlagenen Auto-Hinzufuegen (422) keine weiteren Versuche,
 *  - eigene Events haben source 'lv-cart' und werden hier und in cart.js ignoriert.
 *
 * Vertrag mit der Produktseite (lv-main-product):
 *  - sessionStorage "lv_protection_optout" = "1": Kunde will diese Sitzung keine Protection.
 *    (Der alte Schluessel "lv-protection-off" wird mitgelesen und mitgeschrieben.)
 *  - window.LvCart.isProtectionOff(), .setProtectionOff(bool), .schedule(), .refresh(), .last
 *  - Nach „In den Warenkorb" publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData })
 *    mit der Antwort von /cart/add.js inkl. sections: dann braucht der Abgleich keinen Extra-Request.
 */
(function () {
  'use strict';

  if (window.LvCart && window.LvCart.ready) return;

  var OPT_KEYS = ['lv_protection_optout', 'lv-protection-off'];
  var RES_KEY = 'lv_cart_reserved_until';
  /* Deutscher Rueckfall. Die uebersetzten Texte (lv.cart.*) kommen aus dem Konfig-JSON
     in snippets/cart-drawer.liquid ("txt"), siehe txt(). */
  var TXT = {
    adding: 'Wird hinzugefügt …',
    add: 'Hinzufügen',
    error: 'Das hat nicht geklappt. Bitte versuch es noch einmal.',
    reserved: 'Artikel reserviert für',
    expired: 'Deine Artikel sind nicht mehr reserviert. Jetzt sichern, solange Vorrat reicht.',
    gate: 'Bitte lege mindestens einen Leuchtvolley in den Warenkorb.',
    gateBtn: 'Zum Leuchtvolley',
  };

  var state = {
    last: null,
    queue: Promise.resolve(),
    reconcileQueued: false,
    timer: null,
    budget: 8,
    addFailed: false,
    lastHadProt: null,
    pending: null,
    seq: 0,
    blocked: false,
  };

  /* ------------------------------------------------------------------ Helfer */
  /* PUB_SUB_EVENTS ist in constants.js ein const, also KEINE window-Eigenschaft */
  function pubEvents() {
    return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
  }

  function route(key, fallback) {
    var r = window.routes || {};
    return r[key] || fallback;
  }

  function ssGet(k) {
    try {
      return window.sessionStorage.getItem(k);
    } catch (e) {
      return null;
    }
  }

  function ssSet(k, v) {
    try {
      if (v === null) window.sessionStorage.removeItem(k);
      else window.sessionStorage.setItem(k, v);
    } catch (e) {
      /* gesperrt (Privatmodus): dann gilt pro Seitenaufruf der Standard */
    }
  }

  function isOptOut() {
    for (var i = 0; i < OPT_KEYS.length; i++) {
      var v = ssGet(OPT_KEYS[i]);
      if (v && v !== '0' && v !== 'false') return true;
    }
    return false;
  }

  function setOptOut(on) {
    OPT_KEYS.forEach(function (k) {
      ssSet(k, on ? '1' : null);
    });
  }

  function parseJSON(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  function configEl(root) {
    var scope = root || document;
    return (
      scope.querySelector('script[data-lv-cart-config="drawer"]') ||
      scope.querySelector('script[data-lv-cart-config="page"]') ||
      scope.querySelector('script[data-lv-cart-config]')
    );
  }

  /* Uebersetzter Text aus dem Konfig-JSON, sonst der deutsche Rueckfall aus TXT */
  var txtCache = null;
  function txt(key) {
    if (!txtCache) {
      var el = configEl();
      var cfg = el ? parseJSON(el.textContent) : null;
      if (cfg && cfg.txt && typeof cfg.txt === 'object') txtCache = cfg.txt;
    }
    var v = txtCache ? txtCache[key] : null;
    return typeof v === 'string' && v && !/translation[ _]missing/i.test(v) ? v : TXT[key];
  }

  function readCfg() {
    var el = configEl();
    var cfg = el ? parseJSON(el.textContent) : null;
    if (!cfg || !cfg.prot || !cfg.ball || !cfg.led) return null;
    cfg.gateOff = !!document.querySelector('script[data-lv-cart-config][data-gate="off"]');
    return cfg;
  }

  /* Schnappschuss aus Drawer oder Warenkorbseite (wird mit jeder Section frisch gerendert) */
  function snapshotFrom(root) {
    var el =
      (root || document).querySelector('script[data-lv-cart-config="drawer"]') ||
      (root || document).querySelector('script[data-lv-cart-config="page"]');
    var cfg = el ? parseJSON(el.textContent) : null;
    return cfg && cfg.snapshot && Array.isArray(cfg.snapshot.items) ? cfg.snapshot : null;
  }

  function snapshotFromSections(sections) {
    if (!sections) return null;
    var ids = Object.keys(sections);
    for (var i = 0; i < ids.length; i++) {
      var html = sections[ids[i]];
      if (!html || html.indexOf('data-lv-cart-config') === -1) continue;
      var snap = snapshotFrom(new DOMParser().parseFromString(html, 'text/html'));
      if (snap) return snap;
    }
    return null;
  }

  function isFullCart(data) {
    return !!data && Array.isArray(data.items) && typeof data.item_count === 'number';
  }

  function getCart() {
    return fetch(route('cart_url', '/cart') + '.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin',
    }).then(function (r) {
      return r.json();
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(
        function (d) {
          var failed = !r.ok || !d || (typeof d.status === 'number' && d.status >= 400);
          return { ok: !failed, data: d };
        },
        function () {
          return { ok: false, data: null };
        }
      );
    });
  }

  /* ------------------------------------------------------------------ Analyse */
  function price(it) {
    return typeof it.original_price === 'number' ? it.original_price : it.price || 0;
  }

  function isProt(it, cfg) {
    return (!!cfg.prot.productId && it.product_id === cfg.prot.productId) || /protection/i.test(it.handle || '');
  }

  function isBall(it, cfg) {
    return (
      (!!cfg.ball.productId && it.product_id === cfg.ball.productId) ||
      (!!cfg.ball.type && it.product_type === cfg.ball.type) ||
      (!!cfg.ball.handle && it.handle === cfg.ball.handle)
    );
  }

  /* „2 Bälle" -> 2, „1 Ball" -> 1, Standard-Variante -> 1 (gleiche Regel wie im Liquid) */
  function perUnit(it) {
    if (it.product_has_only_default_variant || !it.variant_title) return 1;
    var n = parseInt(String(it.variant_title).split(' ')[0], 10);
    return n > 0 ? n : 1;
  }

  function analyze(cart, cfg) {
    var a = { units: 0, ball: false, prot: [], gifts: [], protQty: 0, count: 0 };
    ((cart && cart.items) || []).forEach(function (it) {
      if (isProt(it, cfg)) {
        a.prot.push(it);
        a.protQty += it.quantity;
        return;
      }
      if (isBall(it, cfg)) {
        a.ball = true;
        a.units += it.quantity * perUnit(it);
      } else if (price(it) === 0) {
        a.gifts.push(it);
      }
    });
    a.count = Math.max(0, ((cart && cart.item_count) || 0) - a.protQty);
    return a;
  }

  function plan(cart, cfg, a) {
    var up = {};
    var n = 0;
    var add = 0;
    function set(it, q) {
      if (it.quantity !== q) {
        up[it.key] = q;
        n++;
      }
    }

    if (a.units === 0) {
      a.prot.forEach(function (it) {
        set(it, 0);
      });
      a.gifts.forEach(function (it) {
        set(it, 0);
      });
      return { up: up, n: n, add: 0 };
    }

    /* genau EINE Protection-Zeile mit Menge 1, Gratis-Zeile hat Vorrang */
    var keep = null;
    a.prot.forEach(function (it) {
      if (!keep && price(it) === 0) keep = it;
    });
    if (!keep && a.prot.length) keep = a.prot[0];
    a.prot.forEach(function (it) {
      if (it === keep) {
        if (it.quantity > 1) set(it, 1);
      } else {
        set(it, 0);
      }
    });

    if (!keep && cfg.prot.productId && !isOptOut() && !state.addFailed) {
      var entitled = !!cfg.prot.freeId && a.units >= (cfg.freeProtMin || 2);
      add = entitled ? cfg.prot.freeId : cfg.prot.paidId;
    }
    return { up: up, n: n, add: add || 0 };
  }

  /* Protection verschwand ohne uns (z. B. als Zeile entfernt), Baelle sind noch da: Abwahl */
  function noteExternal(a) {
    /* Keine stille Abwahl mehr: Protection soll immer im Korb sein, nur der Schalter schaltet sie ab. */
    state.lastHadProt = a.prot.length > 0;
  }

  /* ------------------------------------------------------------------ Zustand */
  function setLast(cart, cfg) {
    if (!cart || !Array.isArray(cart.items)) return;
    cfg = cfg || readCfg();
    state.last = cart;
    api.last = cart;
    if (!cart.items.length) ssSet(RES_KEY, null);
    state.blocked = computeBlocked(cart, cfg);
    applyGate();
  }

  function computeBlocked(cart, cfg) {
    if (!cfg || cfg.gateOff) return false;
    if (!cart || !cart.items || !cart.items.length) return false;
    return !analyze(cart, cfg).ball;
  }

  /* ------------------------------------------------------------------ Rendern */
  function sectionIds() {
    var ids = [];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    var page = document.querySelector('cart-items[data-section-id]');
    if (page) ids.push(page.getAttribute('data-section-id'));
    return ids;
  }

  function render(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        var target = document.querySelector('#CartDrawer .drawer__inner');
        var source = doc.querySelector('.drawer__inner');
        if (target && source) target.innerHTML = source.innerHTML;
        var drawer = document.querySelector('cart-drawer');
        if (drawer && target) {
          drawer.classList.toggle('is-empty', !!target.querySelector('.drawer__inner-empty'));
          /* Fokus war im ersetzten Inhalt: im offenen Drawer halten */
          if (drawer.classList.contains('active') && !target.contains(document.activeElement) && typeof window.trapFocus === 'function') {
            window.trapFocus(drawer, target);
          }
        }
      } else if (id === 'cart-icon-bubble') {
        var bubble = document.getElementById('cart-icon-bubble');
        var bsrc = doc.querySelector('.shopify-section');
        if (bubble && bsrc) bubble.innerHTML = bsrc.innerHTML;
      } else {
        var page = document.querySelector('cart-items[data-section-id="' + id + '"]');
        var psrc = doc.querySelector('cart-items');
        if (page && psrc) page.innerHTML = psrc.innerHTML;
      }
    });
    afterRender();
  }

  function refocus(selector) {
    if (!selector) return;
    var el = document.querySelector(selector);
    var drawer = document.querySelector('cart-drawer.active');
    if (!el && drawer && selector.indexOf('cart-drawer') === 0) el = drawer.querySelector('.drawer__inner');
    if (!el) return;
    if (drawer && drawer.contains(el) && typeof window.trapFocus === 'function') window.trapFocus(drawer, el);
    else if (typeof el.focus === 'function') el.focus({ preventScroll: true });
  }

  /* Wo wurde geklickt: im Drawer oder auf der Warenkorbseite? */
  function scopeOf(el) {
    return el && el.closest && el.closest('cart-drawer') ? 'cart-drawer' : 'cart-items';
  }

  function showError() {
    var box = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (!box) return;
    var msg = txt('error');
    box.textContent = msg;
    setTimeout(function () {
      if (box.textContent === msg) box.textContent = '';
    }, 6000);
  }

  function announce(data) {
    state.seq++;
    var ev = pubEvents();
    if (ev && typeof window.publish === 'function') {
      window.publish(ev.cartUpdate, { source: 'lv-cart', cartData: data });
    }
    try {
      document.dispatchEvent(new CustomEvent('lv:cart:updated', { detail: state.last }));
    } catch (e) {
      /* alter Browser */
    }
  }

  /* Aenderung ausfuehren: erst Mengen (update.js), dann ggf. Hinzufuegen (add.js).
     opts.auto: automatische Aenderung (Notbremse, 422 merkt sich addFailed)
     opts.strict: Fehler werfen (Nutzeraktion, damit der Schalter zurueckspringt) */
  function mutate(updates, addId, opts) {
    opts = opts || {};
    var ids = sectionIds();
    var hasUpdates = updates && Object.keys(updates).length > 0;
    var chain = Promise.resolve(null);

    if (hasUpdates) {
      chain = chain.then(function () {
        return post(route('cart_update_url', '/cart/update') + '.js', {
          updates: updates,
          sections: ids,
          sections_url: window.location.pathname,
        }).then(function (res) {
          if (res.ok) return res.data;
          return changeEach(updates, ids);
        });
      });
    }

    if (addId) {
      chain = chain.then(function (prev) {
        return post(route('cart_add_url', '/cart/add') + '.js', {
          items: [{ id: addId, quantity: 1 }],
          sections: ids,
          sections_url: window.location.pathname,
        }).then(function (res) {
          if (res.ok) return res.data;
          if (opts.auto) state.addFailed = true;
          if (opts.strict) throw res;
          return prev;
        });
      });
    }

    return chain.then(function (data) {
      if (!data) return null;
      if (data.sections) render(data.sections);
      var cfg = readCfg();
      var fresh = isFullCart(data) ? data : snapshotFromSections(data.sections);
      if (fresh) {
        setLast(fresh, cfg);
        if (cfg) state.lastHadProt = analyze(fresh, cfg).prot.length > 0;
        announce(data);
        refocus(opts.focus);
        return data;
      }
      return getCart().then(function (cart) {
        setLast(cart, cfg);
        if (cfg) state.lastHadProt = analyze(cart, cfg).prot.length > 0;
        announce(data);
        refocus(opts.focus);
        return data;
      });
    });
  }

  /* Rueckfall, falls update.js die Zeilen-Keys ablehnt: Zeile fuer Zeile ueber change.js */
  function changeEach(updates, ids) {
    var keys = Object.keys(updates);
    var last = Promise.resolve(null);
    keys.forEach(function (key, i) {
      last = last.then(function () {
        var body = { id: key, quantity: updates[key] };
        if (i === keys.length - 1) {
          body.sections = ids;
          body.sections_url = window.location.pathname;
        }
        return post(route('cart_change_url', '/cart/change') + '.js', body).then(function (res) {
          if (!res.ok) throw res;
          return res.data;
        });
      });
    });
    return last;
  }

  /* ------------------------------------------------------------------ Warteschlange */
  function enqueue(task) {
    var p = state.queue.then(task);
    state.queue = p.catch(function () {});
    return p;
  }

  function reconcile() {
    state.reconcileQueued = false;
    var cfg = readCfg();
    if (!cfg) return null;
    var pending = state.pending;
    state.pending = null;
    var source =
      pending && pending.seq === state.seq && pending.cart ? Promise.resolve(pending.cart) : getCart();

    return source.then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) return null;
      setLast(cart, cfg);
      var a = analyze(cart, cfg);
      noteExternal(a);
      var p = plan(cart, cfg, a);
      afterRender();
      if (!p.n && !p.add) return null;
      if (state.budget <= 0) return null;
      state.budget--;
      return mutate(p.n ? p.up : null, p.add, { auto: true });
    });
  }

  function schedule(delay) {
    clearTimeout(state.timer);
    state.timer = setTimeout(
      function () {
        if (state.reconcileQueued) return;
        state.reconcileQueued = true;
        enqueue(reconcile).catch(function () {
          /* Netzfehler: Stand behalten, beim naechsten Anlass neu versuchen */
        });
      },
      typeof delay === 'number' ? delay : 200
    );
  }

  /* ------------------------------------------------------------------ Oberflaeche */
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function resetReserve() {
    ssSet(RES_KEY, null);
  }

  function tickReserve() {
    var els = document.querySelectorAll('[data-lv-reserve]');
    if (!els.length) return;
    var mins = parseInt(els[0].getAttribute('data-minutes'), 10) || 5;
    var until = parseInt(ssGet(RES_KEY), 10);
    if (!until) {
      until = Date.now() + mins * 60000;
      ssSet(RES_KEY, String(until));
    }
    var left = Math.max(0, Math.ceil((until - Date.now()) / 1000));
    var text = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var label = el.querySelector('[data-lv-reserve-label]');
      if (!label) continue;
      if (left > 0) {
        el.classList.remove('is-over');
        var t = label.querySelector('[data-lv-reserve-time]');
        if (!t) {
          label.textContent = txt('reserved') + ' ';
          t = document.createElement('b');
          t.className = 'lv-reserve__time';
          t.setAttribute('data-lv-reserve-time', '');
          label.appendChild(t);
        }
        if (t.textContent !== text) t.textContent = text;
      } else if (!el.classList.contains('is-over')) {
        el.classList.add('is-over');
        label.textContent = txt('expired');
      }
    }
  }

  function syncSwitches() {
    var off = isOptOut();
    var boxes = document.querySelectorAll('[data-lv-protect]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var sw = box.querySelector('[data-lv-protect-toggle]');
      if (!sw || sw.getAttribute('aria-busy') === 'true') continue;
      var inCart = box.getAttribute('data-in-cart') === 'true';
      var canAdd = parseInt(box.getAttribute('data-add-id'), 10) > 0;
      /* nicht im Korb, aber nicht abgewaehlt: der Abgleich legt sie gleich rein -> schon „an" zeigen */
      var on = inCart || (!off && canAdd && !state.addFailed && state.budget > 0);
      var val = on ? 'true' : 'false';
      if (sw.getAttribute('aria-checked') !== val) sw.setAttribute('aria-checked', val);
    }
  }

  function applyGate() {
    var blocked = state.blocked;
    var buttons = document.querySelectorAll('button[name="checkout"], input[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      if (blocked) {
        if (!b.disabled) {
          b.disabled = true;
          b.setAttribute('data-lv-gate-disabled', '1');
        }
        b.setAttribute('aria-disabled', 'true');
      } else if (b.getAttribute('data-lv-gate-disabled') === '1') {
        b.disabled = false;
        b.removeAttribute('data-lv-gate-disabled');
        b.removeAttribute('aria-disabled');
      }
    }
    var express = document.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons');
    for (var j = 0; j < express.length; j++) express[j].hidden = blocked;
  }

  function afterRender() {
    syncSwitches();
    tickReserve();
    applyGate();
  }

  /* Sperre zum Klickzeitpunkt: frischester Stand aus der zuletzt gerenderten Section */
  function blockedNow() {
    var cfg = readCfg();
    var snap = snapshotFrom(document);
    return computeBlocked(snap || state.last, cfg);
  }

  function showGateHint(trigger) {
    var hint = document.querySelector('cart-drawer.active [data-lv-gate]') || document.querySelector('[data-lv-gate]');
    if (!hint && trigger && trigger.parentNode) {
      var cfg = readCfg();
      hint = document.createElement('div');
      hint.className = 'lv-gate';
      hint.setAttribute('role', 'alert');
      hint.setAttribute('data-lv-gate', '');
      var p = document.createElement('p');
      p.className = 'lv-gate__text';
      p.textContent = txt('gate');
      var a = document.createElement('a');
      a.className = 'lv-gate__btn';
      a.href = (cfg && cfg.ball && cfg.ball.url) || '/collections/all';
      a.textContent = txt('gateBtn');
      hint.appendChild(p);
      hint.appendChild(a);
      var wrap = document.createElement('div');
      wrap.className = 'lv-cart';
      wrap.style.margin = '0 0 10px';
      wrap.appendChild(hint);
      trigger.parentNode.insertBefore(wrap, trigger);
    }
    if (!hint) return;
    hint.classList.remove('is-nudge');
    void hint.offsetWidth;
    hint.classList.add('is-nudge');
  }

  function fixBubble(snap, cfg) {
    if (!snap || !cfg) return;
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble || bubble.hasAttribute('data-lv-count')) return;
    var count = analyze(snap, cfg).count;
    var num = bubble.querySelector('span[aria-hidden="true"]');
    if (count <= 0) {
      bubble.parentNode.removeChild(bubble);
    } else if (num && num.textContent.trim() !== String(count)) {
      num.textContent = String(count);
    }
  }

  /* ------------------------------------------------------------------ Nutzeraktionen */
  function currentBox(scope) {
    return document.querySelector(scope + ' [data-lv-protect]') || document.querySelector('[data-lv-protect]');
  }

  function onToggle(sw) {
    if (sw.getAttribute('aria-busy') === 'true') return;
    var wantOn = sw.getAttribute('aria-checked') !== 'true';
    var prevOpt = isOptOut();
    var scope = scopeOf(sw);
    sw.setAttribute('aria-checked', wantOn ? 'true' : 'false');
    sw.setAttribute('aria-busy', 'true');
    setOptOut(!wantOn);
    if (wantOn) state.addFailed = false;

    enqueue(function () {
      var box = currentBox(scope);
      if (!box) return null;
      var inCart = box.getAttribute('data-in-cart') === 'true';
      if (wantOn) {
        if (inCart) return null;
        var addId = parseInt(box.getAttribute('data-add-id'), 10) || 0;
        if (!addId) return null;
        return mutate(null, addId, { strict: true, focus: scope + ' [data-lv-protect-toggle]' });
      }
      if (!inCart) return null;
      var updates = {};
      (box.getAttribute('data-keys') || '').split(',').forEach(function (k) {
        if (k) updates[k] = 0;
      });
      if (!Object.keys(updates).length) return null;
      return mutate(updates, 0, { strict: true, focus: scope + ' [data-lv-protect-toggle]' });
    })
      .then(function () {
        var fresh = document.querySelectorAll('[data-lv-protect-toggle][aria-busy="true"]');
        for (var i = 0; i < fresh.length; i++) fresh[i].removeAttribute('aria-busy');
        syncSwitches();
      })
      .catch(function () {
        setOptOut(prevOpt);
        var all = document.querySelectorAll('[data-lv-protect-toggle]');
        for (var i = 0; i < all.length; i++) {
          all[i].removeAttribute('aria-busy');
          all[i].setAttribute('aria-checked', wantOn ? 'false' : 'true');
        }
        showError();
      });
  }

  function setButtonBusy(btn, busy) {
    var label = btn.querySelector('[data-lv-label]') || btn;
    if (busy) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      label.textContent = txt('adding');
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      label.textContent = txt('add');
    }
  }

  function onUpsell(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;
    setButtonBusy(btn, true);
    var scope = scopeOf(btn);
    enqueue(function () {
      return mutate(null, id, { strict: true, focus: scope + ' .lv-checkout' });
    })
      .then(function () {
        resetReserve();
        tickReserve();
        if (document.body.contains(btn)) setButtonBusy(btn, false);
      })
      .catch(function () {
        if (document.body.contains(btn)) setButtonBusy(btn, false);
        showError();
      });
  }

  /* ------------------------------------------------------------------ Events */
  function cartFromEvent(e) {
    var d = e && e.cartData;
    if (!d) return null;
    if (isFullCart(d)) return d;
    return snapshotFromSections(d.sections);
  }

  function onCartUpdate(e) {
    if (!e || e.source === 'lv-cart') return;
    if (e.source === 'product-form' || e.source === 'quick-add' || e.source === 'lv-bundle') resetReserve();
    var cart = cartFromEvent(e);
    state.pending = cart ? { cart: cart, seq: state.seq } : null;
    schedule();
  }

  function observeRenders() {
    if (!('MutationObserver' in window)) return;
    var t = null;
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var node = list[i].target;
        if (!node || node.nodeType !== 1) continue;
        if (
          node.id === 'CartDrawer' ||
          (node.classList && node.classList.contains('drawer__inner')) ||
          node.tagName === 'CART-ITEMS'
        ) {
          clearTimeout(t);
          t = setTimeout(function () {
            var cfg = readCfg();
            var snap = snapshotFrom(document);
            if (snap) setLast(snap, cfg);
            afterRender();
          }, 30);
          return;
        }
      }
    });
    var roots = document.querySelectorAll('cart-drawer, cart-items');
    for (var i = 0; i < roots.length; i++) mo.observe(roots[i], { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    var sw = target.closest('[data-lv-protect-toggle]');
    if (sw) {
      e.preventDefault();
      onToggle(sw);
      return;
    }

    var up = target.closest('[data-lv-upsell-add]');
    if (up) {
      e.preventDefault();
      onUpsell(up);
      return;
    }

    var checkout = target.closest('.lv-checkout');
    if (checkout && !checkout.disabled && !state.blocked) {
      checkout.classList.add('is-loading');
      checkout.setAttribute('aria-busy', 'true');
      setTimeout(function () {
        checkout.classList.remove('is-loading');
        checkout.removeAttribute('aria-busy');
      }, 9000);
    }
  });

  /* Checkout-Sperre: greift vor allen anderen Handlern (Capture-Phase) */
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target && e.target.closest ? e.target.closest('a[href*="/checkout"], button[name="checkout"]') : null;
      if (!t || !blockedNow()) return;
      e.preventDefault();
      e.stopPropagation();
      showGateHint(t);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var sub = e.submitter;
      var action = form.getAttribute('action') || '';
      var isCheckout = (sub && sub.name === 'checkout') || (!sub && action.indexOf('/checkout') !== -1);
      if (!isCheckout || !blockedNow()) return;
      e.preventDefault();
      e.stopPropagation();
      showGateHint(sub || null);
    },
    true
  );

  window.addEventListener('pageshow', function (e) {
    var busy = document.querySelectorAll('.lv-checkout.is-loading');
    for (var i = 0; i < busy.length; i++) {
      busy[i].classList.remove('is-loading');
      busy[i].removeAttribute('aria-busy');
    }
    if (e.persisted) {
      state.pending = null;
      schedule(0);
    }
  });

  document.addEventListener('cart:refresh', function () {
    state.pending = null;
    schedule();
  });

  /* ------------------------------------------------------------------ Start */
  var api = {
    ready: true,
    last: null,
    isProtectionOff: isOptOut,
    setProtectionOff: function (on) {
      setOptOut(!!on);
      if (!on) state.addFailed = false;
      syncSwitches();
    },
    schedule: function () {
      state.pending = null;
      schedule();
    },
    refresh: function () {
      state.pending = null;
      schedule(0);
    },
  };
  window.LvCart = api;

  function init() {
    var cfg = readCfg();
    var snap = snapshotFrom(document);
    if (!snap) {
      var el = configEl();
      var any = el ? parseJSON(el.textContent) : null;
      snap = any && any.snapshot && Array.isArray(any.snapshot.items) ? any.snapshot : null;
    }
    if (cfg && snap) {
      setLast(snap, cfg);
      var a = analyze(snap, cfg);
      state.lastHadProt = a.prot.length > 0;
      fixBubble(snap, cfg);
      var p = plan(snap, cfg, a);
      /* Nur wenn der Schnappschuss Handlungsbedarf zeigt: frisch laden und abgleichen */
      if (p.n || p.add) schedule(0);
    }
    afterRender();
    observeRenders();

    var ev = pubEvents();
    if (ev && typeof window.subscribe === 'function') {
      window.subscribe(ev.cartUpdate, onCartUpdate);
    }

    setInterval(tickReserve, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
